import React from 'react';
import { Modal, Form, Input, FormInstance } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { ChannelIntegrationConfig } from '@/ts/common-types';

interface ConnectClientChannelIntegrationModalProps {
    isOpen: boolean;
    onCancel: () => void;
    onSubmit: () => void;
    loading: boolean;
    channelName: string;
    channelLogo: React.ReactElement;
    form: FormInstance;
    channelConfig: ChannelIntegrationConfig;
}

const ConnectClientChannelIntegrationModal: React.FC<ConnectClientChannelIntegrationModalProps> = ({
    isOpen,
    onCancel,
    onSubmit,
    loading,
    channelName,
    channelLogo,
    form,
    channelConfig
}) => {
    const renderFormFields = () => {
        return channelConfig.authFields.map(field => (
            <Form.Item
                key={field.id}
                name={field.id}
                label={<span className="fw-medium">{field.label}</span>}
                rules={[{ required: field.required, message: `Please enter ${field.label}` }]}
                tooltip={{
                    title: `Enter your ${field.label}`,
                    icon: <InfoCircleOutlined className="ms-1" />
                }}
            >
                {field.id === 'password' ? (
                    <Input.Password
                        className="border"
                        placeholder={field.placeholder || `Enter ${field.label}`}
                        disabled={loading}
                        size="large"
                    />
                ) : (
                    <Input
                        className="border"
                        placeholder={field.placeholder || `Enter ${field.label}`}
                        disabled={loading}
                        size="large"
                    />
                )}
            </Form.Item>
        ));
    };

    return (
        <Modal
            title={
                <div className="d-flex align-items-center">
                    {React.cloneElement(channelLogo, { width: "2rem", height: "2rem" })}
                    <span className="ms-2">
                        {channelConfig.oauthEnabled 
                            ? "Connect Advertising" 
                            : `Connect ${channelName}`
                        }
                    </span>
                </div>
            }
            open={isOpen}
            onCancel={onCancel}
            onOk={onSubmit}
            okText="Connect"
            confirmLoading={loading}
        >
            <Form form={form} layout="vertical">
                {renderFormFields()}
            </Form>
        </Modal>
    );
};

export default ConnectClientChannelIntegrationModal; 